
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useAdminSettings } from "@/hooks/useAdminSettings";

const FAQ = () => {
  const { settings } = useAdminSettings();
  
  const faqs = [
    {
      question: "How does cam‑picking work?",
      answer: "Book an appointment and get the video‑call access details by email. We walk you through categories on camera so you can choose pieces live, then we prepare billing and shipping."
    },
    {
      question: "What are the minimums and purchase rules?",
      answer: "Minimum order is 500€ net from at least four categories. This applies to both CAM‑PICKING and HANDPICKING wholesale sessions so you can mix styles efficiently."
    },
    {
      question: "How long is a session and what happens after?",
      answer: "Sessions are scheduled for up to three hours including about 30 minutes for billing and shipping prep. After you confirm your order, we dispatch quickly and share tracking."
    }
  ];

  return (
    <section className="section-gap-top mb-0" style={{ backgroundColor: 'rgba(27, 33, 57, 0.95)' }}>
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-[#F4F4F4] mb-6">
              {(settings as any)?.faq_section_title || 'Frequently Asked Questions'}
            </h2>
            <p className="text-[#F4F4F4] text-sm md:text-base">
              {(settings as any)?.faq_section_subtitle || 'Get answers to common questions about our website recovery service'}
            </p>
          </div>
          
          <Accordion type="single" collapsible className="space-y-6">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-[#364264]/50 rounded-lg px-6 shadow-sm"
                style={{ backgroundColor: '#364264' }}
              >
                <AccordionTrigger className="text-left font-bold text-[#F4F4F4] hover:text-[#D9992B] text-sm md:text-base">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#F4F4F4] leading-relaxed text-sm md:text-base">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
      
      {/* No bottom padding; spacing is controlled externally */}
    </section>
  );
};

export default FAQ;
